import React, { Component } from 'react'

// ui
import Pagination from '../../components/uielements/pagination'

// redux
import { connect } from 'react-redux'
import mediaActions from '../../redux/qbmedia/actions'

class Paginate extends Component {
    onShowSizeChange = (current, pageSize) => {
        console.log('current : ', current, 'Pagesize : ', pageSize)
        this.props.changePageSize(pageSize)
    }

    onChange(pageNumber) {
        console.log('Page: ', pageNumber)
        this.props.changeCurrentPage(pageNumber)
    }

    render() {
        const { total, pageSize, current } = this.props
        return (
            <div className="PaginateContainer">
                {total > 0 && <Pagination
                    // showSizeChanger
                    onShowSizeChange={(current, pageSize) => this.onShowSizeChange(current, pageSize)}
                    onChange={(pageNumber) => this.onChange(pageNumber)}
                    current={current}
                    pageSizeOptions={['12', '18', '24', '40']}
                    total={total}
                    // showQuickJumper
                    pageSize={pageSize}
                />}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        total: state.qbmedia.total,
        pageSize: state.qbmedia.pageSize,
        current: state.qbmedia.pageIndex
    }
}

const mapDispatchToProps = dispatch => {
    return {
        changePageSize: pageSize => {
            dispatch(mediaActions.action.changePageSize(pageSize))
        },
        changeCurrentPage: pageNumber => {
            dispatch(mediaActions.action.changeCurrentPage(pageNumber))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Paginate)
